export const scrollTo = (id) => {
	const el = document.getElementById(id)
	if (!el) return
	el.scrollIntoView({ behavior: 'smooth' })
	window.history.replaceState(null, '', `#${id}`)
}
